import React, { useRef, useEffect } from 'react';
import SearchWidget from '@arcgis/core/widgets/Search';
import Locator from '@arcgis/core/tasks/Locator';
import Graphic from '@arcgis/core/Graphic';
import Point from '@arcgis/core/geometry/Point';
import popupContent from '../helpers/popupContent';
import setHeaderColor from '../helpers/setPopupHeaderColor';

function AddSearchGraphicToMapAndZoom({ view, map, latitude, longitude }) {
  const point = new Point({
    longitude,
    latitude,
    spatialReference: 4326,
  });

  const markerSymbol = {
    type: 'simple-marker',
    color: [0, 100, 255, 0.9],
    size: 10,
    outline: {
      color: [0, 0, 0, 0.3],
      width: 2,
    },
  };
  const pointGraphic = new Graphic({
    geometry: point,
    symbol: markerSymbol,
  });
  view.graphics.add(pointGraphic);
  view.goTo(pointGraphic);
  view.zoom = 14;
}

export default function Search({
  view,
  map,
  countyBorderLayer,
  countyBorderLayerView,
  selectedLayer,
}) {
  const searchDiv = useRef(null);

  useEffect(() => {
    (async () => {
      const { features } = await countyBorderLayer.queryFeatures();
      let highlight;
      searchDiv.current.innerHTML = '';

      const search = new SearchWidget({
        container: searchDiv.current,
        includeDefaultSources: false,
        locationEnabled: false,
        autoNavigate: true,
        enableInfoWindow: true,
        enableHighlight: true,
        autoSelect: true,
        popupOpenOnSelect: true,
        showInfoWindowOnSelect: true,
        sources: [
          {
            locator: new Locator(
              '//geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer'
            ),
            singleLineFieldName: 'SingleLine',
            autoNavigate: true,
            enableInfoWindow: true,
            enableHighlight: true,
            autoSelect: true,
            popupOpenOnSelect: true,
            showInfoWindowOnSelect: true,
            name: 'Address',
            filter: {
              geometry: features[0].geometry,
            },
            placeholder: '302 N 1st Ave, Phoenix, Arizona',
          },
        ],
      });

      search.on('search-clear', (e) => {
        view.graphics.removeAll();
        view.popup.close();
        if (highlight) {
          highlight.remove();
        }
      });

      search.on('select-result', (e) => {
        view.graphics.removeAll();
        if (highlight) {
          highlight.remove();
        }
        const { latitude, longitude } = e.result.feature.geometry;
        AddSearchGraphicToMapAndZoom({ view, map, latitude, longitude });
        (async () => {
          const activeLayer = map.findLayerById(selectedLayer);
          const activeLayerView = await view.whenLayerView(activeLayer);

          const { features } = await activeLayer.queryFeatures({
            geometry: e.result.feature.geometry,
            outFields: ['*'],
          });

          if (features.length > 0) {
            view.popup.open({
              title: `Selected ${
                selectedLayer === 'BlockGroups' ? 'Block Group' : 'Tract'
              }`,
              location: e.result.feature.geometry,
              content: popupContent(features[0].attributes),
            });

            highlight = activeLayerView.highlight(features[0]);
            const { HH_blw4p50AMI, HH_blw4p80AMI, TOTAL_HH_FOR_INCOME } =
              features[0].attributes;
            const HHvw4p50AMIPct = HH_blw4p50AMI / TOTAL_HH_FOR_INCOME;
            const HHvw4p80AMIPct = HH_blw4p80AMI / TOTAL_HH_FOR_INCOME;

            setHeaderColor(
              HHvw4p50AMIPct >= 0.6
                ? 'rgb(168, 56, 0)'
                : HHvw4p80AMIPct >= 0.6
                ? 'rgb(255, 198, 39)'
                : 'rgb(0,0,0)'
            );
          }
        })();
      });
    })();
  }, [selectedLayer, countyBorderLayer, view, map]);

  return (
    <>
      <div
        style={{
          textAlign: 'center',
          margin: 'auto',
          width: '100%',
          marginTop: '10px',
        }}
        id="search"
        ref={searchDiv}
      ></div>
    </>
  );
}
